<template>
  <div class="page-container">
    <div class="toolbar">
      <el-button type="primary" @click="openModal">新建监控</el-button>
    </div>
    <el-table stripe :data="monitors" border>
      <el-table-column prop="monitorName" label="监控名称" />
      <el-table-column prop="ipAddress" label="IP地址" />
      <el-table-column prop="port" label="端口" />
      <el-table-column prop="status" label="状态">
        <template #default="scope">
          <el-tag :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status === 1 ? '在线' : '离线' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间">
        <template #default="scope">
          {{ formatDateTime(scope.row.createTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template #default="scope">
          <el-button size="small" @click="editMonitor(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="handleDeleteMonitor(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="监控设备信息" v-model="dialogVisible" width="600px">
      <el-form :model="formData" label-width="100px">
        <el-form-item label="监控名称">
          <el-input v-model="formData.monitorName" />
        </el-form-item>
        <el-form-item label="IP地址">
          <el-input v-model="formData.ipAddress" />
        </el-form-item>
        <el-form-item label="端口">
          <el-input v-model="formData.port" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="formData.status">
            <el-option label="在线" :value="1" />
            <el-option label="离线" :value="0" />
          </el-select>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveMonitor">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { getMonitorList, saveMonitor, deleteMonitor } from '../api'
import { formatDateTime } from '../utils/format'

const monitors = ref([])
const dialogVisible = ref(false)
const formData = reactive({
  id: null,
  monitorName: '',
  ipAddress: '',
  port: '',
  status: 1
})

onMounted(() => {
  loadMonitors()
})

const loadMonitors = async () => {
  try {
    const res = await getMonitorList()
    monitors.value = res.data
  } catch (error) {
    ElMessage.error('加载监控设备失败')
  }
}

const openModal = () => {
  Object.assign(formData, { id: null, monitorName: '', ipAddress: '', port: '', status: 1 })
  dialogVisible.value = true
}

const editMonitor = (row) => {
  Object.assign(formData, row)
  dialogVisible.value = true
}

const handleSaveMonitor = async () => {
  try {
    await saveMonitor(formData)
    ElMessage.success('保存成功')
    dialogVisible.value = false
    loadMonitors()
  } catch (error) {
    ElMessage.error('保存失败')
  }
}

const handleDeleteMonitor = async (id) => {
  try {
    await deleteMonitor(id)
    ElMessage.success('删除成功')
    loadMonitors()
  } catch (error) {
    ElMessage.error('删除失败')
  }
}
</script>